import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  brand: {
    id: 'app.containers.ChatbotWidget.brand',
    defaultMessage: 'Brand',
  },
  brandPlaceholder: {
    id: 'app.containers.ChatbotWidget.brandPlaceholder',
    defaultMessage: 'Please select Brand',
  },
});
